import BaseResource from './BaseResource';

export default class MarketplaceProductVariantResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  update(data) {
    return super
      .patch(data)
      .then((response) => response)
      .catch((error) => error.response);
  }

  delete() {
    return super
      .delete()
      .then((response) => response)
      .catch((error) => error.response);
  }
}
